
import { Vue, Component } from 'vue-property-decorator'
import S from '@/store'
import * as T from '@/types'
import config from '@/config'

import { required, email } from 'vuelidate/lib/validators'

import AppWordmark from '@/components/app/AppWordmark.vue'
import UiToggle from '@/components/ui/inputs/UiToggle.vue'

import { 
    UiCard,
    UiFormattedText,
    UiTextInput,
} from '@hubsolv/hubsolv-ui'

@Component({
    components: {
        AppWordmark,
        UiCard,
        UiFormattedText,
        UiTextInput,
        UiToggle,
    },
    validations: {
        email: {
            required,
            email,
        },
        password: {
            required,
        },
    },
})
export default class ViewLogin extends Vue {
    
    ////////////////////////////////////////////////////////////////
    // data
    ////////////////////////////////////////////////////////////////

    email: string = ''
    password: string = ''
    token: string = ''

    loginFailureStatus: number | null = null
    showFirstLoginModal: boolean = false
    showRegisterModal: boolean = false

    ////////////////////////////////////////////////////////////////
    // Vuex bindings
    ////////////////////////////////////////////////////////////////
    
    @S.Auth.Getter loggingIn: any
    @S.Auth.Getter rememberedEmail!: string
    @S.Auth.Getter resolvingRoute!: boolean

    @S.Auth.Mutation setRememberEmail: any

    @S.Auth.Action login: any

    ////////////////////////////////////////////////////////////////
    // computed
    ////////////////////////////////////////////////////////////////

    get rememberEmail () {
        return this.$store.getters['auth/rememberEmail']
    }
    set rememberEmail (value) {
        this.setRememberEmail(value)
    }

    get emailErrors () {
        if (!this.$v) return null
        if (!this.$v.email.$error) return null

        const errors = []
        if (!this.$v.email.required) errors.push('Email address is required.')
        if (!this.$v.email.email) errors.push('This is not a valid email address.')
        return errors
    }

    get passwordErrors () {
        if (!this.$v) return null
        if (!this.$v.password.$error) return null

        const errors = []
        if (!this.$v.password.required) errors.push('Password is required.')
        return errors
    }

    get loading () {
        return this.loggingIn || this.resolvingRoute
    }

    get support () {  
        return {
            email: config.SUPPORT.SUPPORT_EMAIL_ADDRESS,
        }
    }

    get accessCodeLoginRoute () { return { name: T.CrmRoute.AUTH_ACCESS_CODE_LOGIN } } 

    get redirectTo () { return this.$route.query.path }

    ////////////////////////////////////////////////////////////////
    // methods
    ////////////////////////////////////////////////////////////////

    created () {
        if (this.rememberedEmail) {
            this.email = this.rememberedEmail
        }
    }

    async onSubmit () {
        if (!this.$v) return

        this.$v.$touch()

        if (this.$v.$invalid) return

        let response
        try {
            response = await this.login({
                email: this.email,
                password: this.password,
                shouldRedirect: false,
            })
            if (response.data.showFirstLogin){
                this.showFirstLoginModal = true
                this.token = response.data.token
            } else {
                if (this.redirectTo) {
                    this.$router.push({ path: this.redirectTo })
                } else {
                    this.$router.push({ name: config.ROUTE.DEFAULT_AUTHORIZED_ROUTE_NAME })
                }
            }
        } catch (error) {
            console.log('Error logging in:', {error})
            this.loginFailureStatus = error.status
        }
    }

    onClickForgotPassword () {
        this.$router.push({name: T.CrmRoute.AUTH_PASSWORD_RESET})
    }

    onClickFirstLoginModal () {
        this.$router.replace({ name: T.CrmRoute.AUTH_PASSWORD_RESET_CONFIRMED, query: {token: this.token, firstLogin: 'true'} })
    }
    
}
